import React from 'react'
import { ReactComponent as ResetIcon } from './icons/reset.svg'
import { captureEvent } from '../../../../../analytics'
import { analyticsEvents } from '../../../../../analytics/events'
import use3DViewer from '../../../../../hooks/use3DViewer'
function TVReset3DViewer({ className = '' }) {

  const { send } = use3DViewer(null, '3d-viewer')
  return (
    <button
      onClick={() => {
        captureEvent(analyticsEvents.RESET_TAPPED)
        send('reset-view')
      }}
      type="button"
      className={`h-[64px] w-[64px] bg-[#fff] rounded-[4px] flex items-center justify-center shadow-md relative ${className}`}
    >
      <ResetIcon />
    </button>
  )
}

export default TVReset3DViewer
